import util from '../util'

let controller = 'Feriados'
export default Object.assign({}, util.GetCrud(controller, null))